import { Dialog } from './overlays/Dialog'
import styles from './MediaPreviewModal.module.css'

function MediaPreviewModal({ media, onClose }) {
  return (
    <Dialog open={Boolean(media)} title={media?.name || 'Media preview'} onClose={onClose} size="media" contentClassName={styles.contentWrap}>
      {media?.type === 'video' ? (
        <video src={media.url} poster={media.posterUrl} className={styles.content} controls autoPlay playsInline />
      ) : media ? (
        <img src={media.url} alt={media.alt || media.name || 'Media preview'} className={styles.content} />
      ) : null}
    </Dialog>
  )
}

export default MediaPreviewModal
